var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconActivationKeywords01 = function SvgIconActivationKeywords01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_activation_keywords-01_svg2__a",
    x1: -40.06,
    x2: 85.9,
    y1: 95.03,
    y2: 32.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_activation_keywords-01_svg2__a",
    id: "icon_activation_keywords-01_svg2__b",
    x1: -39.29,
    x2: 86.67,
    y1: 96.58,
    y2: 33.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M89.64 0H10.36A10.35 10.35 0 0 0 0 10.36v79.29c0 5.72 4.63 10.36 10.36 10.36h79.29c5.72 0 10.36-4.63 10.36-10.36V10.36C100.01 4.64 95.38 0 89.65 0Zm7.53 89.49a7.67 7.67 0 0 1-7.68 7.68H10.51a7.67 7.67 0 0 1-7.68-7.68V10.51c0-4.23 3.43-7.68 7.68-7.68h78.98a7.67 7.67 0 0 1 7.68 7.68z",
    style: {
      fill: "url(#icon_activation_keywords-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81 61.6h-7.64l-.42 4.57c-.13 1.43-.94 2.36-2.36 2.36h-3.27c-1.31 0-2.36-.85-2.36-2.12 0-.47.04-.89.09-1.51l.62-7.42c.09-.65.2-1.27.38-1.89l6.12-21.6c.42-1.51 1.51-2.54 3.07-2.54h3.92c1.56 0 2.65 1.05 3.07 2.54l6.12 21.6c.18.62.29 1.25.38 1.89l.62 7.39c.04.56.09 1.14.09 1.51 0 1.27-1.05 2.12-2.36 2.12h-3.25c-1.4 0-2.2-.94-2.36-2.36l-.47-4.54Zm-7.13-6.54h6.66L50 40.49z",
    style: {
      fill: "url(#icon_activation_keywords-01_svg2__b)"
    }
  }));
};
export default SvgIconActivationKeywords01;